import script from "./Generator.vue?vue&type=script&setup=true&lang=js"
export * from "./Generator.vue?vue&type=script&setup=true&lang=js"

import "./Generator.vue?vue&type=style&index=0&id=0b690895&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b690895"]])

export default __exports__